<template>
    <PrismicRichText v-if="field && isRichTextField" :id="id" :field="field as RichTextField" class="slice-title" />
</template>
<script setup lang="ts">
    import {useContentHelpers} from '@nuxt-marketing-module/composables/useContentHelpers';
    import {type KeyTextField, type RichTextField} from '@prismicio/types';
    import {PrismicRichText} from '@prismicio/vue';
    import {computed} from '#imports';

    const props = defineProps<{
        field: KeyTextField | RichTextField;
    }>();

    // Composables
    const {textToId, titleFieldToId} = useContentHelpers();

    /**
     * If true it's a RichTextField, otherwise it's a KeyTextField
     * @type {boolean}
     */
    const isRichTextField = computed<boolean>(() => Array.isArray(props.field));
    const id = computed(() => (isRichTextField.value ? titleFieldToId(props.field as RichTextField) : textToId(props.field as string)));
</script>
